import kubernetesLogo from '../../assets/logos/kubernetes.svg'

interface KubernetesLogoProps {
  className?: string
}

/**
 * The Kubernetes brand mark, from devicons (MIT library, mark unmodified).
 *
 * Static, like ReactLogo and NextjsLogo, and for the same reason: this is the Linux
 * Foundation's trademark, not our illustration, and its brand terms do not permit
 * animating or altering it.
 *
 * No dark mode filter. The mark is Kubernetes blue, which reads on both the white and
 * the navy surface, so there is nothing to correct.
 */
const KubernetesLogo = ({ className = 'w-12 h-12' }: KubernetesLogoProps) => (
  <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
    <img src={kubernetesLogo} alt="" aria-hidden="true" className="w-full h-full object-contain" />
  </div>
)

export default KubernetesLogo
